import { useState, useEffect } from 'react';
export var usePrescribingAccessEnable = function (isFetched, erxPrescribingAccess) {
    var _a = useState(false), prescribingAccessEnabled = _a[0], setPrescribingAccessEnabled = _a[1];
    useEffect(function () {
        if (isFetched) {
            setPrescribingAccessEnabled(erxPrescribingAccess);
        }
    }, [erxPrescribingAccess, isFetched]);
    return prescribingAccessEnabled;
};
